<template>

  <div>
    <gmap-marker
      :position="locationUser"
      :icon="{ 
        url: require('../../assets/icons/user_mark.svg'),
        scaledSize: {width: 40, height: 60, f: 'px', b: 'px',},
      }"
      @click="toggleInfoWindowUser">
    </gmap-marker>


    <gmap-info-window
      :position="locationUser"
      :options="infoOptions"
      :opened="infoWinOpen"
      @closeclick="infoWinOpen=false"
    >
      <v-card
        class="overflow-y-auto elevation-0 mx-auto"
        style="max-height: 200px"
      >
        <v-card-text
          class="pt-4"
          style="position: relative;"
        >
          <div class="font-weight-medium subheading black--text text-uppercase">
            Posición actual
          </div>
        </v-card-text>
      </v-card>
    </gmap-info-window>
  </div>
  
</template>

<script>
export default {
  name: "MarkerUser",
  /* Componente del marcador de la posición del Usuario*/
  props: {
    locationUser : Object,
    infoOptions: Object
  }, 
  data() {
    return {
      infoWinOpen: false
    };
  },

  methods: {
    toggleInfoWindowUser: function () {

      this.infoWinOpen = !this.infoWinOpen;
    }
  }
};
</script>

<style scoped>
.v-btn:not(.v-btn--round).v-size--large {
  padding: 3px 9px !important;
}
</style>